import React from 'react'

import { t } from 'i18next'

import { useAuthStore } from 'src/app/auth/interfaces'
import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import { useOverview } from './hooks/use-overview'
import { OverviewTemplate } from './template'

const Overview = (): React.JSX.Element => {
  const userName =
    useAuthStore(state => state.currentUser?.data?.name) ??
    t('overview.limitedPartners')
  const currentDate = DateAdapter.formatToWeekdayMonthDayYear(new Date())
  const {
    recentNewsItems,
    newDocumentItems,
    fundSummaryStats,
    isLoading,
    isFundSummaryLoading,
    isDocumentsLoading,
    selectedDocumentBlobUrl,
    openDocumentPreview,
    closeDocumentPreview,
  } = useOverview()

  return (
    <OverviewTemplate
      userName={userName}
      currentDate={currentDate}
      isLoading={isLoading}
      isFundSummaryLoading={isFundSummaryLoading}
      isDocumentsLoading={isDocumentsLoading}
      fundSummaryStats={fundSummaryStats}
      recentNewsItems={recentNewsItems}
      newDocumentItems={newDocumentItems}
      selectedDocumentBlobUrl={selectedDocumentBlobUrl}
      onDocumentPreviewOpen={openDocumentPreview}
      onDocumentPreviewClose={closeDocumentPreview}
    />
  )
}

export default Overview
